import { render, staticRenderFns } from "./OrderFabricPaintTypeTable.vue?vue&type=template&id=3f3d17fb&"
import script from "./OrderFabricPaintTypeTable.vue?vue&type=script&lang=js&"
export * from "./OrderFabricPaintTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports